import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

import { snackbarService } from '@/services/snackbarService'

export default /*@__PURE__*/_defineComponent({
  __name: 'SnackbarNotification',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _unref(snackbarService).state.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(snackbarService).state.show) = $event)),
    color: _unref(snackbarService).state.color,
    timeout: _unref(snackbarService).state.timeout,
    location: "bottom",
    rounded: "pill"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        color: "white",
        icon: "mdi-close",
        variant: "text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(snackbarService).close()))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(snackbarService).state.color === 'success')
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              icon: "mdi-check-circle",
              class: "mr-2"
            }))
          : (_unref(snackbarService).state.color === 'error')
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 1,
                icon: "mdi-alert-circle",
                class: "mr-2"
              }))
            : (_unref(snackbarService).state.color === 'info')
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 2,
                  icon: "mdi-information",
                  class: "mr-2"
                }))
              : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_unref(snackbarService).state.message), 1)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "color", "timeout"]))
}
}

})